// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1EO2s","footer":"ModalCreateQualiphyProcedure_footer__3eI2V","additionData":"ModalCreateQualiphyProcedure_additionData__3OVLE"};